import { GoogleMedia } from "./googlemedia.model";

export interface IPlayerBar {
    visible?: boolean;
    microMode?: boolean;
    microExtendedMode?: boolean;
    currentTrackIdx?: number;
    currentTrackId?: string;
    currentTrackTotalTime?: string;
    currentTrackCurrentTime?: string;
    currentPosition?: number;
    currentDuration?: number;
    playingProgress?: number;
    playlistName?: string;
    playing?: boolean;
    paused?: boolean;
    musicList?: Array<GoogleMedia>;
    offline?: boolean;
    offlineDirectory?: string;
    playlistImageDir?: string;
    playlistImage?: string;
    programShortName?: string;
    /** When set, player uses this image instead of program logo / Google cover (e.g. library music). */
    fixedAlbumArtUrl?: string;
    isReady?: boolean;
    currentMode?: string;
    isFM?: boolean;
}

export class PlayerBar implements IPlayerBar {
    visible = false;
    microMode = false;
    microExtendedMode = false;
    playing = false;
    paused = false;
    currentTrackIdx = 0;
    currentTrackId = '';
    musicList = new Array<GoogleMedia>();
    currentTrackTotalTime = '00:00';
    currentTrackCurrentTime = '00:00';
    currentPosition = 0;
    currentDuration = 0;
    playingProgress = 100;
    playlistName = '';
    offline = false;
    offlineDirectory = '';
    playlistImageDir = '';
    playlistImage = '';
    programShortName = '';
    fixedAlbumArtUrl = '';
    isReady = true;
    currentMode = '';
    isFM = false;

    constructor() { }
}
